export function getUppyCoreTranslations (translate) {
  return {
    youCanOnlyUploadX: {
      0: translate('uppy.dashboard.upload_limit'),
      1: translate('uppy.dashboard.upload_limit_plural')
    },
    youHaveToAtLeastSelectX: {
      0: translate('uppy.dashboard.minimum_files'),
      1: translate('uppy.dashboard.minimum_files_plural')
    },
    exceedsSize: translate('uppy.exceeds_size'),
    youCanOnlyUploadFileTypes: `${translate('uppy.upload_formats')} %{types}`,
    companionError: translate('uppy.companion_error')
  };
}

export function getUppyDashboardTranslations (translate) {
  return {
    closeModal: translate('uppy.dashboard.close_modal'),
    dashboardWindowTitle: translate('uppy.dashboard.window_title'),
    copyLinkToClipboardSuccess: translate('uppy.dashboard.link_copy_clipboard'),
    copyLinkToClipboardFallback: translate('uppy.dashboard.link_copy_fallback'),
    copyLink: translate('uppy.dashboard.link_copy'),
    fileSource: translate('uppy.dashboard.file_source'),
    done: translate('uppy.dashboard.done'),
    removeFile: translate('uppy.dashboard.remove_file'),
    myDevice: translate('uppy.dashboard.my_device'),
    dropPasteImport: translate('uppy.dashboard.drop_paste_import'),
    dropPaste: translate('uppy.dashboard.drop_paste'),
    browse: translate('uppy.dashboard.browse'),
    uploadComplete: translate('uppy.dashboard.upload_complete'),
    uploading: translate('uppy.dashboard.uploading'),
    complete: translate('uppy.dashboard.complete'),
    resumeUpload: translate('uppy.dashboard.resume_upload'),
    pauseUpload: translate('uppy.dashboard.pause_upload'),
    retryUpload: translate('uppy.dashboard.retry_upload'),
    cancelUpload: translate('uppy.dashboard.cancel_upload'),
    uploadFailed: translate('uppy.dashboard.upload_failed'),
    pleasePressRetry: translate('uppy.dashboard.please_retry'),
    paused: translate('uppy.dashboard.paused'),
    error: translate('uppy.dashboard.error'),
    retry: translate('uppy.dashboard.retry'),
    cancel: translate('general.cancel'),
    dataUploadedOfTotal: translate('uppy.dashboard.uploaded_of_total'),
    xTimeLeft: translate('uppy.dashboard.time_left'),
    addMore: translate('uppy.dashboard.add_more'),
    back: translate('uppy.dashboard.back'),
    addMoreFiles: translate('uppy.dashboard.add_more_files'),
    uploadingXFiles: {
      0: translate('uppy.dashboard.uploading_file'),
      1: translate('uppy.dashboard.uploading_files_plural')
    },
    xFilesSelected: {
      0: translate('uppy.dashboard.files_selected'),
      1: translate('uppy.dashboard.files_selected_plural')
    },
    filesUploadedOfTotal: {
      0: translate('uppy.dashboard.files_of_total'),
      1: translate('uppy.dashboard.files_of_total_plural')
    },
    uploadXFiles: {
      0: translate('uppy.dashboard.upload_files'),
      1: translate('uppy.dashboard.upload_files_plural')
    },
    uploadXNewFiles: {
      0: translate('uppy.dashboard.upload_new_files'),
      1: translate('uppy.dashboard.upload_new_files_plural')
    }
  };
}
